import { AanlgesiaTagTypeType, AnalgesiaTagLocationType } from '../types';
import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';

export interface Analgesia {
  hasAnalgesia: boolean;
  locations: AnalgesiaLocation[];
}

export class AnalgesiaClass implements Analgesia {
  hasAnalgesia: boolean;
  locations: AnalgesiaLocation[];

  constructor(o: any = {}) {
    this.hasAnalgesia = o['hasAnalgesia'] ?? null;
    this.locations = o['locations']
      ? o['locations'].map(
          (location: any) => new AnalgesiaLocationClass(location)
        )
      : [];
  }
}

export interface AnalgesiaLocation {
  id: string;
  location: AnalgesiaTagLocationType;
  type: AanlgesiaTagTypeType;
  time: Date | null;
  userInput: string | null;

  toString(): string;
}

export class AnalgesiaLocationClass implements AnalgesiaLocation {
  id: string;
  location: AnalgesiaTagLocationType;
  type: AanlgesiaTagTypeType;
  time: Date | null;
  userInput: string | null;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.location = o['location'] ?? null;
    this.type = o['type'] ?? null;
    this.time = extractDateTimeStamp(o['time']);
    this.userInput = o['userInput'] ?? null;
  }

  toString(): string {
    return this.userInput || '';
  }
}
